import { Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firbase/firebase";
import Loading from "./components/Loading";

const ProtectedRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);
  // debugger;

  if (loading) {
    return <Loading />; // show loader while Firebase checks
  }

  // console.log("user in ProtectedRoute:", user);

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
